import "../../stylesheets2025/Committee.css";
import iitk_logo from '../../images/iitk_logo.png';
import nitw from "../../images/NITW-logo.png";
import igbc from '../../images/IGBC.jpg';
import iskcon from "../../images/iskcon_logo.jpg";
import iitb from "../../images/IITB_Logo.svg";

const Committee = () => {
    return (
        <div className="committee-container">
            <header className="committee-header">
                <h1>Conference Committee Members</h1>
            </header>

            {/* Chief Patron Section */}
            {/* <section className="committee-section">
                <h2 className="committee-section-title">Chief Patron</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://www.radhanathswami.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Radhanath Swami
                            </a>
                        </h3>
                    </div>
                </div>
            </section> */}

            {/* Patron Section */}
            {/* <section className="committee-section">
                <h2 className="committee-section-title">Patron</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://gaurangadas.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Gauranga Das
                            </a>
                        </h3>
                    </div>
                </div>
            </section> */}

            {/* Organizing Committee */}
            <section className="committee-section">
                <h2 className="committee-section-title">Organizing Committee</h2>
                <div className="committee-grid">
                    {/* <div className="committee-card">
                        <h3>
                            <a
                                href="https://www.linkedin.com/in/chaitanya-gade/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Chaitanya Rupa Das
                            </a>
                        </h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://home.iitk.ac.in/~amarendrae/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Amarendra Edpuganti
                            </a>
                        </h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://www.ctara.iitb.ac.in/en/faculty-profile/prof-pennan-chinnasamy"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Pennan Chinnasamy
                            </a>
                        </h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://home.iitk.ac.in/~gururajmv/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Gururaj MV
                            </a>
                        </h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://www.me.iitb.ac.in/faculty/prof-m-v-rane"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Milind Rane
                            </a>
                        </h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://erp.nitw.ac.in/ext/profile/ce-phari"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Hari Krishna Padavala
                            </a>
                        </h3>
                    </div> */}
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://home.itk.ac.in/~amarendrae/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Prof Amarendra, IIT Kanpur
                            </a>
                        </h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://home.iitk.ac.in/-gururajmv/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Prof Gururaj, IIT Kanpur
                            </a>
                        </h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://www.ctara.iitb.ac.in/en/faculty-profile/prof-p"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Prof Pennan Chinnasamy, IIT Bombay
                            </a>
                        </h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https:llerp.nitw.ac.in/extprofile/ce-phari"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Prof Harikrishna NIT Warangal
                            </a>
                        </h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://www.cranfield.ac.uk/people/dr-sameer-rahatek"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Prof Sameer Rahatekar, Cranfield university
                            </a>
                        </h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https:llwww.linkedin.com/in/chaitanya-gadel"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Mr Chaitanya Rupa Das, Deputy Director, GEV
                            </a>
                        </h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://www.che.iitb.ac.in/faculty-page/sanjay-m-mahajani"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Prof. Sanjay Mahajani, IIT Bombay, Professor incharge GESH
                            </a>
                        </h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            Dr.
                            <a
                                href="https://www.linkedin.com/in/wazeemnishad?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Wazeem Nishad, GESH IIT Bombay
                            </a>
                        </h3>
                    </div>
                </div>
            </section>

            {/* Scientific Committee */}
            <section className="committee-section">
                <h2 className="committee-section-title">Scientific Committee Chair</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://www.cranfield.ac.uk/people/dr-sameer-rahatekar-15445392"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Prof Sameer Rahatekar, Cranfield university
                            </a>
                        </h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://erp.nitw.ac.in/ext/profile/ce-phari"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Prof Harikrishna NIT Warangal
                            </a>
                        </h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://www.ctara.iitb.ac.in/en/faculty-profile/prof-p"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Prof. Pennan Chinnasamy, IIT Bombay                             </a>
                        </h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://home.https://iitk.ac.in/-gururajmv/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Prof. Gururaj MV, IIT Kanpur                            </a>
                        </h3>
                    </div>
                </div>
            </section>

            {/* Finance Coordinator */}
            <section className="committee-section">
                <h2 className="committee-section-title">Finance Coordinator</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://www.linkedin.com/in/pavan-muttepawar-793a15125/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Pavan Muttepawar
                            </a>
                        </h3>
                    </div>
                </div>
            </section>

            {/* Technical & IT Support */}
            <section className="committee-section">
                <h2 className="committee-section-title">Technical & IT Support</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Ram Thangaraj</h3>
                    </div>
                    <div className="committee-card">
                        <h3>Aditya Raj</h3>
                    </div>
                </div>
            </section>

            {/* Media & Promotions */}
            <section className="committee-section">
                <h2 className="committee-section-title">Media & Promotions</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Govardhan Eco Village</h3>
                    </div>

                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://www.linkedin.com/company/iit-bombay-research-hub-for-green-energy-and-sustainability/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                GESH (IITB)
                            </a>
                        </h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://www.linkedin.com/company/kss-iitk/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                KSS (IITK)
                            </a>
                        </h3>
                    </div>
                </div>
            </section>

            {/* Hospitality & Logistics */}
            <section className="committee-section">
                <h2 className="committee-section-title">Hospitality & Logistics</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>Govardhan Eco Village & IIT Bombay</h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://www.linkedin.com/company/iit-bombay-research-hub-for-green-energy-and-sustainability/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                GESH (IITB)
                            </a>
                        </h3>
                    </div>
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://www.linkedin.com/company/kss-iitk/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                KSS (IITK)
                            </a>
                        </h3>
                    </div>
                </div>
            </section>

            {/* Event Coordinator */}
            <section className="committee-section">
                <h2 className="committee-section-title">Event Coordinator</h2>
                <div className="committee-grid">
                    <div className="committee-card">
                        <h3>
                            <a
                                href="https://in.linkedin.com/in/himani-muppalla"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Himani Muppalla
                            </a>
                        </h3>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Committee;
